import { render } from "./SpecificationHTML.vue?vue&type=template&id=4d1b293c"
import script from "./SpecificationHTML.vue?vue&type=script&lang=js"
export * from "./SpecificationHTML.vue?vue&type=script&lang=js"

import "./SpecificationHTML.vue?vue&type=style&index=0&id=4d1b293c&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__